<template lang="pug">
v-card.dashboard-quick-link(
  ripple,
  :class="{ 'dashboard-quick-link--featured': featured }",
  tabindex="0",
  @click="emitNavigate",
  @keydown.enter.prevent="emitNavigate",
  @keydown.space.prevent="emitNavigate"
)
  v-card-text.dashboard-quick-link__content
    .dashboard-quick-link__icon(:style="iconStyle")
      v-icon(size="18", :color="accentColor") {{ icon }}
    span.dashboard-quick-link__label {{ label }}
</template>

<script>
export default {
  name: "QuickLinkButton",
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    to: {
      type: String,
      required: true
    },
    accentColor: {
      type: String,
      default: "#3d82f6"
    },
    featured: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconStyle() {
      return {
        backgroundColor: this.featured ? "rgba(255, 255, 255, 0.9)" : `${this.accentColor}1a`
      };
    }
  },
  methods: {
    emitNavigate() {
      this.$emit("navigate", this.to);
    }
  }
};
</script>

<style scoped>
.dashboard-quick-link {
  width: 100%;
  min-height: 52px;
  height: 52px;
  border: 1px solid #d9e2ef !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 6px rgba(15, 42, 77, 0.08) !important;
  cursor: pointer;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}

.dashboard-quick-link:hover,
.dashboard-quick-link:focus {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(15, 42, 77, 0.1) !important;
  border-color: #c1d2e4 !important;
}

.dashboard-quick-link--featured {
  background: #e5e7ff;
  border-color: #b7bfff !important;
}

.dashboard-quick-link__content {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 100%;
  padding: 10px 14px !important;
}

.dashboard-quick-link--featured .dashboard-quick-link__content {
  justify-content: center;
  gap: 10px;
}

.dashboard-quick-link__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 10px;
  flex-shrink: 0;
}

.dashboard-quick-link__label {
  color: #0a1f44;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
}

.dashboard-quick-link--featured .dashboard-quick-link__label {
  color: #3747ff;
}
</style>
